/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Settings_TitleInputs */

const en_live_caption_settings_title = /** @type {(inputs: Live_Caption_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Captioning Settings`)
};

const fr_live_caption_settings_title = /** @type {(inputs: Live_Caption_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de sous-titrage en direct`)
};

const de_live_caption_settings_title = /** @type {(inputs: Live_Caption_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Untertitelungseinstellungen`)
};

const it_live_caption_settings_title = /** @type {(inputs: Live_Caption_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni dei sottotitoli in tempo reale`)
};

const ru_live_caption_settings_title = /** @type {(inputs: Live_Caption_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки субтитров в реальном времени`)
};

const es_live_caption_settings_title = /** @type {(inputs: Live_Caption_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de subtítulos en directo`)
};

const zh_cn2_live_caption_settings_title = /** @type {(inputs: Live_Caption_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时字幕设置`)
};

const ja_live_caption_settings_title = /** @type {(inputs: Live_Caption_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブキャプション設定`)
};

const hi_live_caption_settings_title = /** @type {(inputs: Live_Caption_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव कैप्शनिंग सेटिंग्स`)
};

const pt_pt2_live_caption_settings_title = /** @type {(inputs: Live_Caption_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de legendagem ao vivo`)
};

/**
* | output |
* | --- |
* | "Live Captioning Settings" |
*
* @param {Live_Caption_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_settings_title = /** @type {((inputs?: Live_Caption_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_settings_title(inputs)
	if (locale === "de") return de_live_caption_settings_title(inputs)
	if (locale === "it") return it_live_caption_settings_title(inputs)
	if (locale === "ru") return ru_live_caption_settings_title(inputs)
	if (locale === "es") return es_live_caption_settings_title(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_settings_title(inputs)
	if (locale === "ja") return ja_live_caption_settings_title(inputs)
	if (locale === "hi") return hi_live_caption_settings_title(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_settings_title(inputs)
	return en_live_caption_settings_title(inputs)
});